import Config from '@/config';
import {
  NotificationListResult,
  NotificationDetail,
} from '@/types/api/notification';
import http, { HttpPromise } from './http';

const list = (role: string, params?: NotificationListResult): HttpPromise<NotificationListResult> => http.get<NotificationListResult>(`${Config.apiHost}/notifications/list/`, { params });
const detail = (role: string, params: { id: number }): HttpPromise<NotificationDetail> => http.get<NotificationDetail>(`${Config.apiHost}/notifications/detail/`, { params });

export default {
  supplier: {
    list: list.bind(this, 'supplier'),
    detail: detail.bind(this, 'supplier'),
  },
  contractor: {
    list: list.bind(this, 'contractor'),
    detail: detail.bind(this, 'contractor'),
  },
  customer: {
    list: list.bind(this, 'customer'),
    detail: detail.bind(this, 'customer'),
  },
  administrator: {
    list: list.bind(this, 'administrator'),
    detail: detail.bind(this, 'administrator'),
  },
  quantity: async (): Promise<HttpPromise> => http.get(`${Config.apiHost}/notifications/quantity/`),
};
